var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, Tooltip, Typography, styled } from '@mui/material';
import { isNumber } from 'lodash';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { METRICS_ENUM, SUMMARY_KEYS } from './enum';
import { getSummaryBoxes, useReportSummaryData, useVarianceColor } from './selectors';
var ACTUAL_BOX = 'actual';
var StyledGrid = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(12.5rem, 1fr))',
        gap: theme.spacing(8),
        padding: theme.spacing(0, 3),
    });
});
var StyledBox = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2.5, 3.5, 3.5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        height: '100%',
        minHeight: '5.5rem',
        border: "0.0625rem solid ".concat(theme.palette.divider),
        borderRadius: '0.3125rem',
        position: 'relative',
    });
});
var StyledTypographyLabel = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.grey[600],
        fontWeight: 'bold',
        lineHeight: 'normal',
    });
});
var StyledTypographyValue = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.typography.pxToRem(26),
        fontWeight: 'bold',
        lineHeight: 'normal',
    });
});
var StyledTypographyIcon = styled(Typography)(function () { return ({
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
}); });
export var DataPanelSummaryBoxes = function () {
    var t = useTranslation('report', { keyPrefix: 'actual.summaryBoxes' }).t;
    var summaryData = useReportSummaryData();
    var watch = useFormContext().watch;
    var _a = watch(), metricTab = _a.metricTab, actualAttritionMode = _a.actualAttritionMode, queueLocationId = _a.queueLocationId;
    var getVarianceColor = useVarianceColor(metricTab);
    var getAbandonmentRateColor = useVarianceColor(METRICS_ENUM.ABANDONMENT_RATE);
    var items = useMemo(function () {
        return getSummaryBoxes(metricTab).filter(function (item) { return queueLocationId === undefined || queueLocationId === -1 || item.key !== SUMMARY_KEYS.ABANDONMENT_RATE; });
    }, [metricTab, queueLocationId]);
    var getStyling = function (key, value) {
        var styling = {
            color: '',
        };
        if (!isNumber(value))
            return styling;
        if (key === SUMMARY_KEYS.VARIANCE) {
            styling.color = getVarianceColor(value);
        }
        if (key === SUMMARY_KEYS.ABANDONMENT_RATE) {
            styling.color = getAbandonmentRateColor(value);
        }
        return styling;
    };
    return (_jsx(StyledGrid, { children: items.map(function (item) {
            return (_jsx(Grid, __assign({ item: true }, { children: _jsxs(StyledBox, { children: [summaryData.isMissingInterval && item.key === ACTUAL_BOX && (_jsx(Tooltip, __assign({ title: t('missingValueHoverText'), arrow: true, color: "warning", placement: "top" }, { children: _jsx(StyledTypographyIcon, __assign({ color: "warning.main" }, { children: _jsx(FontAwesomeIcon, { icon: "triangle-exclamation", size: "lg" }) })) }))), _jsx(StyledTypographyLabel, { children: t("".concat(metricTab, ".").concat(item.key), { defaultValue: item.key }) }), _jsx(StyledTypographyValue, __assign({ sx: getStyling(item.key, summaryData[item.key]) }, { children: item.formatter(metricTab, summaryData[item.key], actualAttritionMode) || '-' }))] }) }), item.key));
        }) }));
};
